import { dataUndo } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUndo = /*#__PURE__*/createIcon(dataUndo)
export default IconUndo
